export default "__VITE_ASSET__B9LN$D6g__"